<mat-card appearance="outlined" class="card">
  @if (editMode) {
  <mat-card-title mat-dialog-title i18n>Edit Document</mat-card-title>
  } @if (!editMode) {
  <mat-card-title mat-dialog-title i18n>Enter New Document</mat-card-title>
  }

  <mat-card-content>
    <form [formGroup]="form">
      <div class="flex-col space-between-none">
        <mat-form-field style="flex: 1 1">
          <mat-label i18n="@@directory">Directory</mat-label>
          <mat-select formControlName="directory" [compareWith]="compareFn">
            <mat-option [value]="null">[.]</mat-option>
            @for (parent of (directories$ | async); track parent) {
            <mat-option [value]="parent">{{ parent.name }}</mat-option>
            }
          </mat-select>
          <button matSuffix matIconButton aria-label="Clear">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <mat-form-field style="flex: 1 1 70%">
          <mat-label i18n>External Id (opt.)</mat-label>
          <input matInput formControlName="externalId" />
        </mat-form-field>
        @if (config?.departmentsEnable === true && data.libraryType ===
        LibraryT.PUBLIC ) {
        <mat-form-field style="flex: 1 1">
          <mat-label i18n="@@departments">Departments</mat-label>
          <mat-select formControlName="departmentsUuids" multiple>
            @for (department of (departments$ | async); track department) {
            <mat-option [value]="department.uuid">{{
              department.name
            }}</mat-option>
            }
          </mat-select>
          <button matSuffix matIconButton aria-label="Clear">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        } @if (!editMode) {
        <mat-form-field style="flex: 1 1">
          <mat-label i18n="@@fileType">File type</mat-label>
          <mat-select formControlName="type" (selectionChange)="onTypeChange()">
            @for (fileType of docTypes | keyvalue; track fileType) {
            <mat-option [value]="fileType.key">{{ fileType.value }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (form.controls.type.value !== null) {
        <input
          type="file"
          class="file-input"
          accept=".{{ docTypes[form.controls.type.value] }}"
          (change)="onFileSelected($event)"
          #fileUpload
        />
        <div class="fxFlexFill">
          <div class="file-upload">
            <div style="font-style: italic; font-weight: 300">
              {{ fileName || "-" }}
            </div>
            @if (!uploadProgress) {
            <button
              matMiniFab
              color="primary"
              class="upload-btn"
              (click)="fileUpload.click()"
            >
              <mat-icon>attach_file</mat-icon>
            </button>
            }
          </div>
        </div>
        <div class="flex-row end-center gap-20">
          @if (uploadProgress) {
          <mat-progress-bar class="progress-bar"
            mode="determinate"
            [value]="uploadProgress"
           />
          } @if (uploadProgress) {
          <mat-icon class="cancel-upload" (click)="cancelUpload()"
            >highlight_off
          </mat-icon>
          }
        </div>
        } }
        <mat-form-field style="flex: 1 1 70%">
          <mat-label i18n>Name</mat-label>
          <input matInput formControlName="name" />
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <div class="flex-row end-center gap-20" mat-dialog-actions>
      <button matButton="outlined" (click)="onCloseClick()" i18n="buttonClose">
        Close
      </button>
      @if (!uploadOK) {
      <button
        matButton="elevated"
        color="accent"
        (click)="onSave()"
        [disabled]="!form.valid || (fileName === '' && !editMode)"
        i18n="@@buttonSave"
      >
        Save
      </button>
      }
    </div>
  </mat-card-actions>
</mat-card>
